/** @format */

import { useContext } from "react";
import { CheckResponsiveContext } from "../../../Context/CheckResponsiveContext";
import { customFormRecievedProps } from "../CustomFormType";
import CustomFormMobileView from "../Components/CustomFormMobileView";
import CustomForm from "../Components/CustomForm";

function CustomFormContainer({
  questionId,
  isPreview,
  surveyAnswersInfo,
  dispatch,
  surveyAnswers,
}: customFormRecievedProps) {
  const { isMobile } = useContext(CheckResponsiveContext);

  return (
    <>
      {isMobile ? (
        <CustomFormMobileView
          dispatch={dispatch}
          isPreview={isPreview}
          surveyAnswersInfo={surveyAnswersInfo}
          questionId={questionId}
          surveyAnswers={surveyAnswers}
        />
      ) : (
        <CustomForm
          dispatch={dispatch}
          isPreview={isPreview}
          surveyAnswersInfo={surveyAnswersInfo}
          questionId={questionId}
          surveyAnswers={surveyAnswers}
        />
      )}
    </>
  );
}

export default CustomFormContainer;
